import { render, staticRenderFns } from "./editTask.vue?vue&type=template&id=4bff3930&scoped=true"
import script from "./editTask.vue?vue&type=script&lang=js"
export * from "./editTask.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bff3930",
  null
  
)

export default component.exports